import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { openPaymentsPortal } from '../redux/actions/commonReduxActions';
import { useAppDispatch } from '../redux/store';
export const PurchaseJacksButton = () => {
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        dispatch(openPaymentsPortal());
    }, [dispatch]);
    return (_jsx(Button, { onClick: onClick, variant: 'contained', color: 'secondary', startIcon: _jsx(ShoppingCartRoundedIcon, {}), children: "Purchase Jacks" }));
};
